import * as Configuration from '../../../app.constants.js';

AddAccountBusinessChatLandingPageController.$inject = ['$scope', 'TopToolbarFactory', '$state', '$stateParams', '$http', 'ConfirmationFactory', 'AlertingFactory'];
export function AddAccountBusinessChatLandingPageController($scope, TopToolbarFactory, $state, $stateParams, $http, ConfirmationFactory, AlertingFactory) {
  
  $scope.submit = submit;

  init();

  function submit() {
    ConfirmationFactory.materialConfirmDialog(
      'add-account/business-chat-lp/please-confirm', 
      {
        'businessName': $scope.businessName,
        'businessId': $scope.businessId
      },
      'add-account/business-chat-lp/please-confirm-ok-button'
    ).then(() => createBzcAuthThenCreateSiteThenGoToConfirmation());
  }

  function createBzcAuthThenCreateSiteThenGoToConfirmation() {
    const endpointURI = Configuration.constants.baseUrl + 'api/1.0/companies/' + $stateParams.companyId 
                        + '/business-chat/create-auth';
    const data = {
      name: $scope.businessName,
      business_id: $scope.businessId
    };
    $http.post(endpointURI, data)
      .then(response => createSiteThenGoToConfirmation(response.data.rid),
            AlertingFactory.httpErrorHandler());
  }

  function createSiteThenGoToConfirmation(requestId) {
    const endpointURI = Configuration.constants.baseUrl + 'api/1.0/companies/' + $stateParams.companyId + '/sites';
    const data = { 
      authorization_id: requestId, 
      type: 'business-chat'
    };
    $http.post(endpointURI, data)
      .then(response => $state.go('auth.alcmeon.parameters.business-chat-add-account-confirmation', 
                                  { createdSiteId: response.data.id }),
            AlertingFactory.httpErrorHandler());
  }

  function init() {
    TopToolbarFactory.setTitleTranslation('add-account/business-chat-lp/title', $scope);

    const urlParams = new URLSearchParams(window.location.search);
    $scope.businessId = urlParams.get('id');
    $scope.businessName = urlParams.get('name');
  }
  
  
}
